'use client'

import { useTheme } from 'next-themes'
import { useSyncExternalStore } from 'react'
import { Toaster } from 'sileo'

/**
 * SSR-safe "are we hydrated yet?" flag without a setState-in-effect
 * pattern (which the React 19 lint rules forbid). Server snapshot
 * always returns false; client snapshot always returns true, so
 * `isHydrated` flips to true on first client render after hydration.
 */
const subscribeToHydration = () => () => {}
const getHydratedClientSnapshot = () => true
const getHydratedServerSnapshot = () => false

/**
 * Theme-aware Sileo Toaster.
 *
 * Light mode → dark fill (#171717) with light description text
 * Dark mode  → light fill (#FAFAFA) with dark description text
 * Pinned to top-center per app convention.
 */
export function ThemeToaster() {
  const { resolvedTheme } = useTheme()
  const isHydrated = useSyncExternalStore(
    subscribeToHydration,
    getHydratedClientSnapshot,
    getHydratedServerSnapshot
  )

  // Before hydration, render with a sensible default (dark fill) so the
  // SSR markup matches the most common state. The toaster has no rendered
  // content until a toast fires, so any hydration delta is invisible.
  const isDark = isHydrated ? resolvedTheme === 'dark' : false

  return (
    <Toaster
      position="top-center"
      options={{
        fill: isDark ? '#FAFAFA' : '#171717',
        styles: {
          description: isDark ? '!text-neutral-700' : '!text-neutral-300',
        },
      }}
    />
  )
}
